import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_generate_data = createAsyncThunk("generate", async (body) => {
  const responce = await fetch(baseUrl + "generatelist", {
    method: "POST",
    body: body,
  });
  const res = await responce.json();
  console.log("generate", res);
  return res;
});

const generateSlice = createSlice({
  name: "generate",
  initialState: {
    generate_list: [],
    generate_loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(get_generate_data.pending, (state, action) => {
      state.generate_loading = true;
    });
    builder.addCase(get_generate_data.rejected, (state, action) => {
      state.generate_loading = false;
    });
    builder.addCase(get_generate_data.fulfilled, (state, action) => {
      state.generate_loading = false;
      const data = action.payload;
      if (data.success) {
        state.generate_list = data.list;
      } else {
        state.generate_list = [];
      }
    });
  },
});
export default generateSlice.reducer;
